import { render } from "./removeseating.vue?vue&type=template&id=52a2f2b7"
import script from "./removeseating.vue?vue&type=script&lang=js"
export * from "./removeseating.vue?vue&type=script&lang=js"

import "./removeseating.vue?vue&type=style&index=0&id=52a2f2b7&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__